import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { Language } from '../translations/content';
import { MatrixRain } from './MatrixRain';
export function LanguageSelector() {
  const {
    setLanguage,
    hasSelectedLanguage,
    setHasSelectedLanguage
  } = useLanguage();
  const handleSelectLanguage = (lang: Language) => {
    setLanguage(lang);
    setHasSelectedLanguage(true);
  };
  if (hasSelectedLanguage) return null;
  return <AnimatePresence data-id="element-91">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-matrix-bg px-4" data-id="element-92">
        {/* Matrix Rain Animation */}
        <div className="absolute inset-0 z-0" data-id="element-93">
          <MatrixRain data-id="element-94" />
        </div>

        {/* Background glow */}
        <div className="absolute inset-0 overflow-hidden z-10" data-id="element-95">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-matrix-accent/10 rounded-full blur-[150px]" data-id="element-96" />
        </div>

        <motion.div initial={{
        scale: 0.9,
        opacity: 0,
        y: 20
      }} animate={{
        scale: 1,
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.5,
        ease: 'easeOut'
      }} className="relative z-20 text-center w-full max-w-4xl mx-auto" data-id="element-97">
          {/* Logo/Title */}
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="mb-12 px-4" data-id="element-98">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-matrix-text mb-2 leading-tight" data-id="element-99">
              ROMPE LA MATRIX{' '}
              <span className="text-matrix-accent text-glow block sm:inline" data-id="element-100">
                3-6-9
              </span>
            </h1>
            <div className="h-1 w-32 mx-auto bg-gradient-to-r from-transparent via-matrix-accent to-transparent" data-id="element-101" />
          </motion.div>

          {/* Language prompt */}
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.6
        }} className="text-matrix-text-muted text-base sm:text-lg md:text-xl mb-8 px-4" data-id="element-102">
            Select your language / Selecciona tu idioma
          </motion.p>

          {/* Language buttons */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.8
        }} className="flex flex-col sm:flex-row gap-6 justify-center px-4" data-id="element-103">
            <motion.button onClick={() => handleSelectLanguage('en')} className="group relative px-8 sm:px-12 py-6 bg-matrix-bg-light border-2 border-matrix-accent/50 rounded-xl text-matrix-text font-bold text-lg sm:text-xl transition-all duration-300" whileHover={{
            scale: 1.05,
            borderColor: 'rgba(0, 217, 255, 1)',
            boxShadow: '0 0 30px rgba(0, 217, 255, 0.4)'
          }} whileTap={{
            scale: 0.98
          }} data-id="element-104">
              <span className="relative z-10" data-id="element-105">English</span>
              <div className="absolute inset-0 bg-gradient-to-r from-matrix-accent/0 via-matrix-accent/10 to-matrix-accent/0 opacity-0 group-hover:opacity-100 transition-opacity rounded-xl" data-id="element-106" />
            </motion.button>

            <motion.button onClick={() => handleSelectLanguage('es')} className="group relative px-8 sm:px-12 py-6 bg-matrix-bg-light border-2 border-matrix-accent-secondary/50 rounded-xl text-matrix-text font-bold text-lg sm:text-xl transition-all duration-300" whileHover={{
            scale: 1.05,
            borderColor: 'rgba(0, 255, 204, 1)',
            boxShadow: '0 0 30px rgba(0, 255, 204, 0.4)'
          }} whileTap={{
            scale: 0.98
          }} data-id="element-107">
              <span className="relative z-10" data-id="element-108">Español</span>
              <div className="absolute inset-0 bg-gradient-to-r from-matrix-accent-secondary/0 via-matrix-accent-secondary/10 to-matrix-accent-secondary/0 opacity-0 group-hover:opacity-100 transition-opacity rounded-xl" data-id="element-109" />
            </motion.button>
          </motion.div>

          {/* Decorative tagline */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1.2
        }} className="mt-16 px-8 md:px-16" data-id="element-110">
            <p className="text-matrix-accent text-xs md:text-sm font-light tracking-wide uppercase opacity-70 max-w-2xl mx-auto" data-id="element-111">
              Prepárate para salir de la Matrix. / Get ready to exit the Matrix.
            </p>
          </motion.div>
        </motion.div>

        {/* Corner decorations */}
        <div className="absolute top-8 left-8 w-16 h-16 border-l-2 border-t-2 border-matrix-accent/30 z-20" data-id="element-112" />
        <div className="absolute top-8 right-8 w-16 h-16 border-r-2 border-t-2 border-matrix-accent/30 z-20" data-id="element-113" />
        <div className="absolute bottom-8 left-8 w-16 h-16 border-l-2 border-b-2 border-matrix-accent/30 z-20" data-id="element-114" />
        <div className="absolute bottom-8 right-8 w-16 h-16 border-r-2 border-b-2 border-matrix-accent/30 z-20" data-id="element-115" />
      </motion.div>
    </AnimatePresence>;
}